import restCrudActions from "../../np-crud/store/restCrudActions";
import { snackActions } from '../../sc-utilities/SnackBar';
import { getAxiosInstance } from "../../np-rest/rest";

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'media',
    pluginName: 'MEDIA',
    entityName: 'MEDIA_GALLERY',
});

export const deleteMediaInit = () => {
    return crudActions.deleteInit();
};
export const deleteMediaStart = () => {
    return crudActions.deleteStart();
};
export const deleteMediaSuccess = deleted => {
    return crudActions.deleteSuccess(deleted);
};
export const deleteMediaFail = error => {
    return crudActions.deleteFail(error);
};
export const deleteMedia = (params, isSignature) => {
    const path = isSignature ? 'signatures/delete' : 'media/delete';
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(deleteMediaStart());
        try {
            let res = await rest.post(path, params);
            if (res.data && res.data.succeeded) {
                dispatch(deleteMediaSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted media.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            dispatch(deleteMediaFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot delete media."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot delete media."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(deleteMediaFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};

export const uploadProgress = (data) => {
    return {
        type: 'MEDIA|PROGRESS',
        progress: data.progress,
        loadSize: data.loadSize,
        maxSize: data.maxSize,
        snackStart: data.snackStart

    };
};

// Upload media action creators
export const uploadMediaInit = () => {
    return crudActions.createInit();
};
export const uploadMediaStart = () => {
    return crudActions.createStart();
};
export const uploadMediaSuccess = uploadedMedia => {
    return crudActions.createSuccess(uploadedMedia);
};
export const uploadMediaFail = error => {
    return crudActions.createFail(error);
};

export const uploadMedia = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(uploadProgress({ progress: null, loadSize: null, maxSize: null, snackStart: true }))
        dispatch(uploadMediaInit());
        try {
            let maxSize = 0;
            let overallSize = 0;

            data.getAll('files[]').forEach(file => overallSize += file.size);

            const config = {
                onUploadProgress: progressEvent => {
                    maxSize = Math.round((progressEvent.total / 1024));
                    dispatch(uploadProgress({
                        progress: (Math.round((progressEvent.loaded * 100) / overallSize) < 100 ? Math.round((progressEvent.loaded * 100) / overallSize) : '100'),
                        loadSize: Math.round((progressEvent.total / 1024)) < Math.round((progressEvent.loaded / 1024)) ? Math.round((progressEvent.loaded / 1024)) : Math.round((progressEvent.total / 1024)),
                        maxSize: Math.round((progressEvent.total / 1024)),
                        snackStart: true
                    }))
                }
            }
            dispatch(uploadMediaStart());
            let res = await rest.post('media/upload', data, config);
            if (res.status === 200) {
                dispatch(uploadMediaSuccess());
                dispatch(uploadProgress({ progress: 100, loadSize: maxSize, maxSize: maxSize, snackStart: false }))
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : 'Media upload was successful.'}`,
                    options: {
                        variant: 'success'
                    }
                });
                return true;
            }
            else {
                dispatch(uploadProgress({ progress: 0, loadSize: 0, maxSize: 0, snackStart: false }))
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                });
                dispatch(uploadMediaFail());
                return false;
            }
        } catch (error) {
            dispatch(uploadProgress({ progress: 0, loadSize: 0, maxSize: 0, snackStart: false }))

            snackActions.snackBar({
                message: `${error && error.message ? error.message : 'Cannot upload media.'}`,
                options: {
                    variant: 'error'
                }
            });
            dispatch(uploadMediaFail());
            return false;
        }
    }
}